import UserRole from "../../slices/settings/user_role/UserRole"
import UserType from "../../slices/settings/user_type/UserType"
import Module from "../../slices/settings/module/Module"
import Action from "../../slices/settings/action/Action"
import Permission from "../../slices/settings/permission/Permission"

const settingsReducer = {
    userRole: UserRole,
    userType: UserType,
    module: Module,
    action: Action,
    permission: Permission,
};

export default settingsReducer;